'use strict';

var ChartFbcApplicabilityDirective = function ChartFbcApplicabilityDirective($filter, Chart, Viewport, chartFormatter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/chart-fbc-applicability.html'),
    controller: 'ChartFbcApplicabilityController',
    scope: {
      filterData: '='
    },
    link: function link($scope, element) {
      var maxVpOneDayRangeSelection = 25;
      var chartDataMissing = element.find('.data-missing');
      var textMessage = chartDataMissing.find('.text-message');
      var chartFormatters = {
        xAxisTickFormatter: function xAxisTickFormatter(d, i) {
          var format = i % 4 === 0 ? 'DAY_MONTH_SHORT_NAME' : 'DAY_OF_MONTH';
          return rmMomentFormat(d, format);
        },
        yAxisTickFormatter: chartFormatter.humanReadable,
        tooltipFormatter: $scope.tooltipFormatter,
        xAxisTickViewportFormatter: $scope.createXAxisViewportFormatter()
      };
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, chartFormatters, $scope.chartModel);
      var viewport = new Viewport(viewportElement, chartFormatters);
      viewport.on('rangechange', function (range) {
        $scope.setViewportSelection(range);
        chart.render();
      });
      $scope.setChartVisibility = function (visible) {
        element.toggleClass('active', visible);
      };
      $scope.renderChartDataPresent = function () {
        var maxBrushSelection = $scope.chartModel.minRange * maxVpOneDayRangeSelection;
        viewport.render($scope.chartModel.data.grouped, $scope.chartModel.getXAxisValues, maxBrushSelection);
      };
      $scope.$on('brush-filter:filterApplied', $scope.reloadChart);
      $scope.$watch('filterData', function () {
        var classUsageFilter = $scope.filterData['class-usage'];
        $scope.reloadChart(classUsageFilter);
      }, true);
      $scope.setErrorMessage = function (data) {
        var caption = '';
        if (data === undefined) {
          caption = 'Error retrieving data';
        } else if (data.length === 0) {
          caption = 'No FBC Applicability Usage';
        }
        textMessage.text(caption);
      };
      $scope.viewportReset = function () {
        viewport.resetBrushSelection();
      };
    }
  };
};
ChartFbcApplicabilityDirective.$inject = ['$filter', 'ChartFbcApplicability', 'ChartFbcApplicabilityViewport', 'FormatterService'];
module.exports = ChartFbcApplicabilityDirective;